// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_LQU","cls2":"BulkFollowPreview-cls2_7n1 BulkFollowPreview-cls1_LQU","compact":"BulkFollowPreview-compact_MHZ"};